import { Badge, BadgeId } from '../Models';

export default class DogeBadge extends Badge {
  public readonly id = BadgeId.doge;
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/doge.ts